@if (icon) {
<href [link]="iconLink || false">
    <span class="_icon"
          [ngClass]="(iconRight ? 'm-l-' : 'm-r-')+ offset"
          [lineHeightBy]="textClass">
        <i [ngClass]="'icon-' + icon"
           [class.icon-small]="iconSmall"></i>
    </span>
</href>
}

<span [ngClass]="[textClass]"
      class="inline-block va-m _copy">
    <ng-content></ng-content>
</span>